import React, { useEffect, useState } from 'react'
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom'
import Login from 'pages/Login'
import Dasboard from 'pages/Dasboard'
import NotFoundPage from 'pages/404'
import MainDashBoard from 'pages/Dasboard/MainDashBoard'
import UserManagementMainPage from 'pages/UserManagement'
import TradingAccountMainPage from 'pages/TradingAccount'
import { ThemeProvider } from 'components/provider/theme'
import UserMainPage from 'pages/User'
import RoleMainPage from 'pages/Role'
import MyDailyReading from 'pages/Daily/MyDailyReading'
import CoachDaily from 'pages/CoachDaily/MyCoachDaily'
import MyDailyReading1 from 'pages/Numerology/MyDailyReading'
import AddDailyReading from 'pages/Daily/AddDailyReading'
import AddDailyReading1 from 'pages/Numerology/AddDailyReading'
import EditDailyReading from 'pages/Daily/EditDailyReading'
import EditCoachDaily from 'pages/CoachDaily/EditCoachDaily'
import EditDailyReading1 from 'pages/Numerology/EditDailyReading'
import TransactionMainPage from 'pages/Transaction'
import { API_URL } from 'env'
import { DataProvider } from 'components/provider/data'
import ListProduct from 'pages/Product/ListProduct'
import ListRecomendation from 'pages/Recomendation/ListRecomendation'
import ListPoint from 'pages/Point/ListPoint'
import AddPoint from 'pages/Point/AddPoint'
import EditPoint from 'pages/Point/EditPoint'
import ListBots from 'pages/Bots/ListBots'
import AddBots from 'pages/Bots/AddBots'
import EditBots from 'pages/Bots/EditBots'
import EditRecomendation from 'pages/Recomendation/EditRecomendation'
import AddProduct from 'pages/Product/AddProduct'
import AddCoachDaily from 'pages/CoachDaily/AddCoachDaily'
import AddRecomendation from 'pages/Recomendation/AddRecomendation'
import EditProduct from 'pages/Product/EditProduct'
import ListProductSection from 'pages/Product-Section/ListProduct-Section'
import AddProductSection from 'pages/Product-Section/AddProduct-Section'
import EditProductSection from 'pages/Product-Section/EditProduct-Section'
import ListProductIntroduction from 'pages/Product-Introduction/ListProduct-Introduction'
import AddProductIntroduction from 'pages/Product-Introduction/AddProduct-Introduction'
import EditProductIntroduction from 'pages/Product-Introduction/EditProduct-Introduction'
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PermissionPage from 'pages/Role/permissionList'
import Subscriptions from 'pages/Subscriptions'
import EventPage from 'pages/Event'
import EventDetail from 'pages/Event/detail'
import CreateEvent from 'pages/Event/component/createEvent'
import HelpPage from 'pages/Help'
import LibraryPage from 'pages/Library'
import StoreMainPage from 'pages/Stores'
import StoreItems from 'pages/Stores/item'

declare global {
  interface Window {
    DOMAIN_API: string;
    SITE_ID: string;
  }
}

const App: React.FC = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const token = localStorage.getItem('token')
  const [checkLogin, setCheckLogin] = useState(false)

  useEffect(() => {
    async function checkAccessRole() {
      const accessControl = await fetch(`${API_URL}api/v1/be/users`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      })
      const response = await accessControl.json()
      if (!response.status) {
        localStorage.removeItem('token')
        navigate('/login')
      }
    }
    const notLogin = ['/login']
    if (notLogin.includes(location.pathname) === false && !token) {
      navigate('/login')
    }
    if (notLogin.includes(location.pathname) === true && token) {
      navigate('/')
    }
    setCheckLogin(true)
  }, [navigate, location.pathname, token])

  return (
    <>
      <DataProvider>
        <ThemeProvider>

          {checkLogin &&
            <Routes>
              <Route path='/login' element={<Login />} />
              <Route path='/' element={<MainDashBoard />} />
              <Route path='/users' element={<UserManagementMainPage />} />
              <Route path='/users/:userID' element={<UserMainPage />} />
              <Route path='/accounts' element={<TradingAccountMainPage />} />
              <Route path='/transactions' element={<TransactionMainPage />} />
              <Route path='/subscriptions' element={<Subscriptions/>} />
              <Route path='/role' element={<RoleMainPage />} />
              <Route path='/permissions' element={<PermissionPage />} />
              <Route path='/daily' element={<MyDailyReading />} />
              <Route path='/numerology' element={<MyDailyReading1 />} />
              <Route path='/coach-daily' element={<CoachDaily />} />
              <Route path='/numerology/edit/:id' element={<EditDailyReading1 />} />
              <Route path='/coach-daily/edit/:id' element={<EditCoachDaily />} />
              <Route path='/add-daily' element={<AddDailyReading />} />
              <Route path='/add-numerology' element={<AddDailyReading1 />} />
              <Route path='/add-daily/edit/:id' element={<EditDailyReading />} />
              <Route path='/product' element={<ListProduct />} />
              <Route path='/recomendation' element={<ListRecomendation />} />
              <Route path='/point' element={<ListPoint />} />
              <Route path='/bots' element={<ListBots />} />
              <Route path='/add-product' element={<AddProduct />} />
              <Route path='/add-coach-daily' element={<AddCoachDaily />} />
              <Route path='/add-recomendation' element={<AddRecomendation />} />
              <Route path='/add-point' element={<AddPoint />} />
              <Route path='/add-bots' element={<AddBots />} />
              <Route path='/add-product/edit/:id' element={<EditProduct />} />
              <Route path='/add-point/edit/:id' element={<EditPoint />} />
              <Route path='/add-recomendation/edit/:id' element={<EditRecomendation />} />
              <Route path='/add-bots/edit/:id' element={<EditBots />} />
              <Route path='/product-section' element={<ListProductSection />} />
              <Route path='/add-product-section' element={<AddProductSection />} />
              <Route path='/add-product-section/edit/:id' element={<EditProductSection />} />
              <Route path='/product-introduction' element={<ListProductIntroduction />} />
              <Route path='/add-product-introduction' element={<AddProductIntroduction />} />
              <Route path='/add-product-introduction/edit/:id' element={<EditProductIntroduction />} />
              <Route path='/events' element={<EventPage />} />
              <Route path='/events/create' element={<CreateEvent />} />
              <Route path='/events/:id' element={<EventDetail />} />
              <Route path='/library' element={<LibraryPage />} />
              <Route path='/help' element={<HelpPage />} />
              <Route path='/stores' element={<StoreMainPage />} />
              <Route path='/stores/item' element={<StoreItems />} />
            </Routes >
          }
        </ThemeProvider>
      </DataProvider>

      <ToastContainer style={{ zIndex: 99999 }} />
    </>
  )
}


export default App
